import { render, staticRenderFns } from "./CollectFile.vue?vue&type=template&id=701331ea&scoped=true&"
import script from "./CollectFile.vue?vue&type=script&lang=ts&"
export * from "./CollectFile.vue?vue&type=script&lang=ts&"
import style0 from "./CollectFile.vue?vue&type=style&index=0&id=701331ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701331ea",
  null
  
)

export default component.exports